import PropTypes from "prop-types";
import { childrenPropType, classNamePropType } from "../../common";

/**
 * PropTypes for ContainerItem component
 *
 * @property {React.ReactNode} children - Item content
 * @property {number} [sm] - Column span for small screens (1-12)
 * @property {number} [md] - Column span for medium screens (1-12)
 * @property {number} [lg] - Column span for large screens (1-12)
 * @property {number} [xl] - Column span for extra large screens (1-12)
 * @property {string} [className] - Additional CSS classes
 */
export const containerItemPropTypes = {
  children: childrenPropType,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  className: classNamePropType,
};
